import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import RecuperarSenha from './pages/RecuperarSenha';
import RedefinirSenha from './pages/RedefinirSenha';
import SelecionarTenant from './pages/SelecionarTenant';
import Dashboard from './pages/Dashboard';
import Veiculos from './pages/Veiculos';
import Departamentos from './pages/Departamentos';
import Motoristas from './pages/Motoristas';
import Solicitacoes from './pages/Solicitacoes';
import Abastecimentos from './pages/Abastecimentos';
import PrecosCombustivel from './pages/PrecosCombustivel';
import Fechamentos from './pages/Fechamentos';
import Manutencoes from './pages/Manutencoes';
import Postos from './pages/Postos';
import Relatorios from './pages/Relatorios';
import Margens from './pages/Margens';
import Imagens from './pages/Imagens';
import Usuarios from './pages/Usuarios';
import Tenants from './pages/Tenants';

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
};

const DefaultRedirect: React.FC = () => {
  const { hasRole } = useAuth();
  if (hasRole('SUPER_ADMIN')) return <Navigate to="/tenants" />;
  if (hasRole('MOTORISTA')) return <Navigate to="/solicitacoes" />;
  return <Navigate to="/dashboard" />;
};

const AppRoutes: React.FC = () => {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <Login />} />
      <Route path="/selecionar-tenant" element={<SelecionarTenant />} />
      <Route
        path="/recuperar-senha"
        element={isAuthenticated ? <Navigate to="/" /> : <RecuperarSenha />}
      />
      <Route path="/redefinir-senha" element={<RedefinirSenha />} />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Layout />
          </PrivateRoute>
        }
      >
        <Route index element={<DefaultRedirect />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="veiculos" element={<Veiculos />} />
        <Route path="departamentos" element={<Departamentos />} />
        <Route path="motoristas" element={<Motoristas />} />
        <Route path="solicitacoes" element={<Solicitacoes />} />
        <Route path="abastecimentos" element={<Abastecimentos />} />
        <Route path="precos-combustivel" element={<PrecosCombustivel />} />
        <Route path="manutencoes" element={<Manutencoes />} />
        <Route path="postos" element={<Postos />} />
        <Route path="relatorios" element={<Relatorios />} />
        <Route path="margens" element={<Margens />} />
        <Route path="imagens" element={<Imagens />} />
        <Route path="usuarios" element={<Usuarios />} />
        <Route path="fechamentos" element={<Fechamentos />} />
        <Route path="tenants" element={<Tenants />} />
      </Route>
      <Route path="*" element={<Navigate to={isAuthenticated ? "/" : "/login"} />} />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
};

export default App;
